import { cn } from '@/lib/utils';
import React from 'react';

const Wrapper = ({ children, className }) => {
  return <div className={cn('my-8 mx-4 md:my-20', className)}>{children}</div>;
};

export default Wrapper;
